import dayjs from 'dayjs';
import {getDateTimeString} from '../../../utils';
import {
  DateTimePeriod,
  PeriodPaddingMinutes,
  ScheduleCalendarType,
} from '../types';
import {getPeriod} from './getPeriod';

/**
 * Returns period with padding, from date/time inclusive and to exclusive,
 * e.g. ('2021-02-24', 'day') => ('2021-02-23T22:00:00', '2021-02-25T01:59:59');
 * @param date
 * @param calendarType
 */
export const getPeriodWithPadding = (
  date: Date | string,
  calendarType: ScheduleCalendarType,
): DateTimePeriod => {
  const {from, to} = getPeriod(date, calendarType);
  const padding = PeriodPaddingMinutes[calendarType];
  return {
    fromDateTime: getDateTimeString(dayjs(from).subtract(padding, 'minutes')),
    toDateTime: getDateTimeString(dayjs(to).add(padding, 'minutes')),
  };
};
